import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import getExternalLinkProperties from '$utils/getExternalLinkProperties';
import ExternalLink from './ExternalLink';
import { Container } from './ExternalLink.styled';
import * as TYPES from '$variables/types';

const AutoLaunchExternalLink = ({
  assignment,
  isEducator,
  launchTurnitinAssignment,
  launchTurnitinSubmission,
}) => {
  const { endDate, externalId, id, provider, space, studentGrade, submission } =
    assignment;

  const externalLinkRef = useRef(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => externalLinkRef.current.click(), 1000);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <Container>
      <span>You will be redirected to your assignment.</span>
      <span>If it's not working, click the "View" button below.</span>
      <ExternalLink
        ref={externalLinkRef}
        assignment={assignment}
        {...getExternalLinkProperties({
          space,
          externalId,
          id,
          provider,
          studentGrade,
          isEducator,
          launchTurnitinAssignment,
          launchTurnitinSubmission,
          submission,
          endDate,
        })}
      />
    </Container>
  );
};

// Define PropTypes for validation
AutoLaunchExternalLink.propTypes = {
  assignment: PropTypes.shape(TYPES.Assignment).isRequired,
  isEducator: PropTypes.bool.isRequired,
  launchTurnitinAssignment: PropTypes.func.isRequired,
  launchTurnitinSubmission: PropTypes.func.isRequired,
};

export default AutoLaunchExternalLink;
